import { useQuery } from '@tanstack/react-query';
import { SheetFeatureApi } from 'api/sheet/sheet-feature-api';
import { useAccountDataQuery } from 'queries/account';
export const useSheetsFeature = ()=>{
    var _isSheetsEnabled_data;
    const { data } = useAccountDataQuery();
    const isSheetsEnabled = useQuery({
        queryKey: [
            'isSheetsEnabled'
        ],
        queryFn: ()=>{
            var _data_account, _data_account1;
            return (data === null || data === void 0 ? void 0 : (_data_account = data.account) === null || _data_account === void 0 ? void 0 : _data_account.accountId) ? SheetFeatureApi.isSheetsEnabled(data === null || data === void 0 ? void 0 : (_data_account1 = data.account) === null || _data_account1 === void 0 ? void 0 : _data_account1.accountId) : Promise.resolve({
                enabled: false
            });
        }
    });
    return !!((_isSheetsEnabled_data = isSheetsEnabled.data) === null || _isSheetsEnabled_data === void 0 ? void 0 : _isSheetsEnabled_data.enabled);
};
